export default __webpack_public_path__ + "static/media/bottle2.6015ec57.svg";